import ApiHttp from '../http';
import Observable from '../util/observable'
import Order from '../model/Order';
import LoyaltyCard from '../model/LoyaltyCard';
import SeatGrid from '../model/SeatGrid'
import Transaction from '../model/Transaction';
import Booking from '../model/Booking';
import ModelArray from '../model/ModelArray'
import AuthService from './auth-service'

const ORDER_CHANGED_EVENT = "ORDER_CHANGED";

const SESSION_KEY = "PendingOrder";
const SESSION_EXPIRY = 900; // 15 minutes;

class OrderService extends Observable {

    get ORDER_CHANGED_EVENT() {
        return ORDER_CHANGED_EVENT;
    }

    constructor() {
        super();
        this._order_promise = undefined;
        this._history_promise = undefined;
        this.concessions_promises = {};
        this.booking = undefined
        this._order = undefined;
        this.seatGrid = [];
        this.CinemaId = undefined;
        this.SessionId = undefined;
    }

    _handleRejection(rejection, cancelOrder = true) {
        this._order_promise = cancelOrder ? undefined : this._order_promise;
        return Promise.reject(rejection)
    }

    _processOrder(order) {

        if (!this._order) {
            this._order = new Order(order);
        } else {
            this._order.setOrder(order)
        }

        this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);

        return this._order;
    }

    getConsessionsByCinemaId(cinema_id) {
        return ApiHttp.get(`/order/concessions/${cinema_id}`).then((response) => response.data);
    }

    getConcessionsForCinema() {
        var CinemaId = this.CinemaId || this.pendingSession().CinemaId
        return this.getConsessionsByCinemaId(CinemaId);
    }

    newOrder(SessionId, CinemaId, MovieId) {
        this.tearDown();
        if (this._order_promise) {
            this._order_promise._clearTracking();
        }
        AuthService.clearTempLocalUserOrderInfo();
        return this._order_promise = ApiHttp.post('/order', {
            SessionId,
            CinemaId,
        }).then(
            (response) => {
                this.setCurrentPendingSession(SessionId, CinemaId, MovieId);
                return this._processOrder(response.data)
            }, (e) => {
                return this._handleRejection(e)
            });
    }

    restartOrder() {
        this._order = undefined;
        let pendingSession = this.pendingSession();
        return this.newOrder(pendingSession.SessionId, pendingSession.CinemaId, pendingSession.MovieId);
    }

    addToOrder(SessionId, CinemaId, MovieId) {
        return this._order_promise = ApiHttp.post('/order/add', {
            SessionId,
            CinemaId,
        }).then(
            (response) => {
                this.setCurrentPendingSession(SessionId, CinemaId, MovieId);
                return this._processOrder(response.data)
            }, (e) => {
                return this._handleRejection(e)
            });
    }

    getOrder(SessionId = (this.pendingSession() ? this.pendingSession().SessionId : null)) {
        return this._order_promise = this._order_promise ||
            ApiHttp.get('/order' + (SessionId && `/${SessionId}` || '')).then((response) => this._processOrder(response.data), (rejection) => this._handleRejection(rejection))
    }

    saveOrder() {
        return this._order_promise = ApiHttp.put('/order', {
            Order: this._order
        }).then((response) => this._processOrder(response.data), (rejection) => this._handleRejection(rejection));
    }

    cancelOrder(session_id, cinema_id) {
        return ApiHttp.post("/order/cancel", {SessionId: session_id, CinemaId: cinema_id}).then(response => {
            this.clearPendingSessions();
            this.clearLoyalties();
            AuthService.clearTempLocalUserOrderInfo();
            return response
        }, (error) => {
            this.clearPendingSessions();
            this.clearLoyalties();
            AuthService.clearTempLocalUserOrderInfo();
            return Promise.reject(error)
        });
    }

    saveTickets() {
        if (!this._order.Tickets || this._order.Tickets.length == 0) {
            return Promise.reject("Order Missing Tickets");
        }
        return ApiHttp.put('/order/tickets', {
            Order: this._order
        }).then((response) => this._processOrder(response.data), (rejection) => this._handleRejection(rejection));
    }

    validateLoyaltyForOrder(card) {
        return new Promise((resolve, reject) => {
            if (!card instanceof LoyaltyCard) card = new LoyaltyCard(card);

            card.setSessionInfo(this.pendingSession().SessionId, this.pendingSession().CinemaId);
            if (card.isPopulated) {
                ApiHttp.post('/cards/validate', card
                ).then(
                    (result) => {
                        //todo logic that handles the card data:

                        resolve(result.data);
                    },
                    (error) => (reject(error))
                );

            } else {
                reject("Card Validation Failed, please ensure Card Number, and Loyalty Type have been selected.")
            }

        });
    }

    pendingSession() {
        if (!this._pendingSession || this._pendingSession.length == 0) {
            try {
                //todo check if sessionEXPIRED
                this._pendingSession = JSON.parse(localStorage.getItem(SESSION_KEY));
            }
            catch (e) {
            }
        }
        return this._pendingSession;
    }

    setCurrentPendingSession(SessionId, CinemaId, MovieId) {

        this._pendingSession = {SessionId, CinemaId, expiry: Date.now(), MovieId};
        try {
            localStorage.setItem(SESSION_KEY, JSON.stringify(this._pendingSession));
        } catch (e) {
        }
    }

    log() {
        // console.log("SG:", ...arguments)
    }

    _generateGrid(SeatData, tickets = []) {

        // let areas = SeatData.Areas.sort((a, b) => a.Number - b.Number) //removed sorting to reply on sequence from vista
        //console.log("_generateGrid")
        let areas = SeatData.Areas
        let seats = {},
            grid = {};

        for (let i = 0; i < areas.length; i++) {
            let area = areas[i];
            let rows = area.Rows.reverse();

            for (let j = 0; j < area.RowCount; j++) {
                let row = rows[j],
                    seatsFormatted = [];
                let seatsLength = row.Seats.length
                let rowIndexZeroBased = row.RowIndexZeroBased

                /*get the grid:*/
                if (row && row.PhysicalName) {
                    grid[row.PhysicalName] = grid[row.PhysicalName] || [];
                    let seats = row.Seats;

                    let tmpSeats = [];
                    let excluded = [];



                    for (let k = area.ColumnCount; k >= 0; k--) {
                        // for (let k = 0; k < area.ColumnCount; k++) {

                        let seat = seats.find((s) => s.Position.ColumnIndex == k)

                        let seatObj = {}

                        if(!seat) {
                            seatObj = {
                                seatNumber: Number(k),
                                seatName: row.PhysicalName + (k),
                                seatNameCombined: [row.PhysicalName + (k)],
                                seatNameCombinedString: row.PhysicalName + (k),
                                seatNumberComined: [Number((k))],
                                selected: false,
                                Position: {
                                    AreaCategoryCode: area.AreaCategoryCode,
                                    ColumnIndex: k,
                                    RowIndex: j,
                                },
                                empty: true,
                                broken: false,
                                aisle: true,
                                available: false,
                                loveNest: false,
                                companion: false,
                                wheelchair: false,
                                selected_unavailable: false,
                                size: 1,
                                dBox: false,
                                kids: false,
                                seats: false,
                                style: undefined,
                                rowIndexZeroBased: rowIndexZeroBased
                            };

                            
                            if(Number(k) >= seatsLength) {
                                seatObj.style = 0
                            } else {
                                seatObj.style = 0
                            }
                        } else {
                            seatObj = {
                                seatNumber: Number((seat && seat.Id || k)),
                                seatName: row.PhysicalName + (seat && seat.Id || k),
                                seatNameCombined: [row.PhysicalName + (seat && seat.Id || k)],
                                seatNameCombinedString: row.PhysicalName + (seat && seat.Id || k),
                                seatNumberComined: [Number((seat && seat.Id || k))],
                                selected: false,
                                Position: {
                                    AreaCategoryCode: area.AreaCategoryCode,
                                    ColumnIndex: seat ? seat.Position.ColumnIndex : null,
                                    RowIndex: seat ? seat.Position.RowIndex : null,
                                },
                                empty: !(seat) || !!(~[2, 4, 5, 6].indexOf(seat.Status)),
                                broken: seat && !seat.Id,
                                aisle: (!seat),
                                loveNest: seat && ((seat.SeatStyle === 1 || seat.SeatStyle === 2 || seat.SeatStyle === 3)),
                                companion: seat && seat.Status === 7,
                                wheelchair: seat && seat.Status === 3,
                                size: seat && seat.SeatsInGroup && seat.SeatsInGroup.length || 1,
                                dBox: area.AreaCategoryCode == '0000000005',
                                kids: (seat && ((seat.Priority === 2))) ? true : false,
                                available: seat && !(~[1, 2, 4, 5, 6].indexOf(seat.Status)),
                                selected_unavailable: false,
                                seats: [seat],
                                style: seat.SeatStyle,
                                rowIndexZeroBased: rowIndexZeroBased
                            };
                        }
                        

                        //according to vista docs SEATSTYLE = 1 is a seat style for the left hand side of a grouped seat.
                        if (seat) {
                            seat.Position.AreaCategoryCode = area.AreaCategoryCode
                            if (seat.SeatStyle == 1) {
                                let m = k - 1,
                                    previousSeat = seats.find((s) => s.Position.ColumnIndex == m);
                                let seatName = '';
                                // go back and add grouped seats to this seat object
                                while (previousSeat && previousSeat.SeatStyle > 1) {
                                    seatName = row.PhysicalName + previousSeat.Id;
                                    previousSeat.Position.AreaCategoryCode = area.AreaCategoryCode;

                                    // if any of the seats in here are broken - set the group to inactive and not bookable.
                                    if ((~[1, 2, 4, 5, 6].indexOf(previousSeat.Status))) {
                                        seatObj.sold = true;
                                        seatObj.empty = false;
                                        seatObj.available = false;
                                    }
                                    previousSeat.Position.AreaCategoryCode = area.AreaCategoryCode
                                    seatObj.seats.push(previousSeat);
                                    // seatObj.seatNumberCombined.push(Number(previousSeat.Id));
                                    seatObj.seatNameCombined.push(seatName);
                                    seatObj.seatNumberComined.push(Number(previousSeat.Id));
                                    m--;
                                    previousSeat = seats.find((s) => s.Position.ColumnIndex == m);
                                }
                                seatObj.seatNameCombinedString += ' - ' + seatName;
                                // reset the index to after these group seats.
                                k = m + 1;
                            }
                        }

                        if (seatObj.empty) {
                            seatObj.type = 0
                        } else if (seatObj.loveNest) {
                            seatObj.type = 2
                        } else if (seatObj.wheelchair) {
                            seatObj.type = 3;
                        } else if (seatObj.companion) {
                            seatObj.type = 4;
                        } else {

                            seatObj.type = 1;
                        }

                        if (grid[row.PhysicalName][k]) {
                            if (grid[row.PhysicalName][k].empty) {
                                grid[row.PhysicalName][k] = seatObj;
                            } else {
                                excluded.push(seatObj);
                            }

                        } else {
                            grid[row.PhysicalName][k] = seatObj;
                        }

                        //console.log("seatObj", seatObj)

                        tmpSeats.push(seatObj);
                        // if(seatObj.Position.AreaCategoryCode != "0000000005" && seatObj.type != 1) {
                            
                        //     console.log("pushed", seatObj)
                        // } else {
                        //     console.log("not pushed", seatObj)
                        // }
                    }

                    // console.log("grid[row.PhysicalName]", row.PhysicalName, grid[row.PhysicalName])

                    // grid[row.PhysicalName].sort((a,b) => (a.seatNumber < b.seatNumber)? 1 : -1)
                }
            }


        }

        //console.log("before format", grid)

        var gridFormatted = Object.keys(grid).reduce((collection, key) => {
            var seats = grid[key];
            let rowIndex = grid[key][0]['rowIndexZeroBased']
            collection.push({PhysicalName: key, RowIndex: rowIndex, Seats: Object.keys(seats).map((k) => seats[k]).reverse()});
            return collection;
        }, []);

        var sortedGridFormatted = gridFormatted.sort(function(a,b) {
            let x = a.RowIndex
            let y = b.RowIndex

            if(x>y) return -1;
            if(x<y) return 1;
            return 0;
        })

        //console.log("gridFormatted", gridFormatted)

        grid = new SeatGrid(gridFormatted);
        if (tickets.length) grid.mapTicketsToGrid(tickets);

        for(let g = 0; g < grid.grid.length; g++) {
            if(grid.grid[g] != undefined) {
                if(grid.grid[g].Seats != undefined) {
                    for(let s = 0; s < grid.grid[g].Seats.length; s++) {
                        if(grid.grid[g].Seats[s] != undefined) {
                            if(grid.grid[g].Seats[s].seatNameCombined.length > 1) {

                                let prevIndex = (s-1)
                                if(grid.grid[g].Seats[prevIndex] != undefined) {

                                    if(grid.grid[g].Seats[prevIndex].Position.AreaCategoryCode == "0000000005") {
                                        grid.grid[g].Seats.splice(prevIndex,1)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return grid
    }

    getSeatGrid(SessionId, CinemaId, tickets = []) {
        return this.seatGrid[SessionId] = this.seatGrid[SessionId] || ApiHttp.get(`/seats/` + CinemaId + `/` + SessionId).then(
            (result) => (this._generateGrid(result.data, tickets)),
            (error) => {
                this.seatGrid[SessionId] = undefined;
                return Promise.reject(error)
            })
    }

    pollPayment(requestNumber = 0) {

        let delay = (time = 3000) => {
            return new Promise((resolve) => {
                setTimeout(() => resolve(), time)
            })
        }

        let retries = 40;
        return ApiHttp.get('/payment/poll-payment', {}).then(response => {
            if (response.data.OrderIdentifiers.IsCompletedOrder === true && response.data.OrderWebPaymentData.PaymentStatus === "P") {
                return Promise.resolve(response.data);
                // success
            } else if (response.data.OrderWebPaymentData.PaymentStatus === "P" && requestNumber < retries) {
                // poll
                return delay(1000).then(() => this.pollPayment(requestNumber + 1));
            } else {
                // some other failure
                // console.log("rejecting poll payment");
                return Promise.reject(response.data);
            }

        });
    }

    pollTJPayment(sessionId, requestNumber = 0) {

        let delay = (time = 3000) => {
            return new Promise((resolve) => {
                setTimeout(() => resolve(), time)
            })
        }

        let retries = 40;
        return ApiHttp.get('/payment/poll-tj-payment?sessionId='+sessionId, {}).then((response) => {
            
            if (response.data.Booking.IsPaid === true) {
                // success
                return Promise.resolve(response.data.Booking);
            } else if (response.data.Booking.IsPaid === false && requestNumber < retries) {
                // poll
                return delay(1000).then(() => this.pollTJPayment(sessionId, requestNumber + 1));
            } else {
                // some other failure
                // console.log("rejecting poll payment");
                return Promise.reject(undefined);
            }

        });
    }

    completeTJOrder(sessionId) {
        return this.pollTJPayment(sessionId).then((r)=> {
            let bookingState = r.OrderIdentifiers;
            this.tearDown()
            return {bookingNumber: bookingState.VistaBookingNumber, bookingId: bookingState.VistaBookingId, CinemaId: bookingState.CinemaId};
        },(r)=> {
            return Promise.reject(r);
        }).catch(e=>{

        });
    }

    completeOrder(orderPayload) {
        return this.pollPayment().then((r)=> {
            let bookingState = r.OrderIdentifiers;
            this.tearDown()
            return {bookingNumber: bookingState.VistaBookingNumber, bookingId: bookingState.VistaBookingId, CinemaId: bookingState.CinemaId};
        },(r)=> {
            return Promise.reject(r);
        }).catch(e=>{

        });
    }

    tearDown() {
        this.clearPendingSessions();
        this.clearLoyalties();
        AuthService.clearTempLocalUserOrderInfo();
        this._order = undefined;
        this._order_promise = undefined;
    }

    /*@DEPRECATING::*/
    getTimeToPendingSessionxpiration() {
        return this.pendingSession()
            ? this.pendingSession().expiry - Date.now()
            : 0
    }

    _refreshPendingSession() {
        var session = this.pendingSession();
        session.expiry = this._getNewPendingSessionExpiryDate();


    }

    _getNewPendingSessionExpiryDate() {
        var date = Date.now()
        session.expiry = date.setSeconds(date.getSeconds() + SESSION_EXPIRY);
    }

    setPendingSession(SessionId, CinemaId, MovieId) {
        // this._order = order;
        this._order.SessionId = SessionId;
        this._order.CinemaId = CinemaId;
        this._pendingSession = {SessionId, CinemaId, expiry: Date.now(), MovieId};
        try {
            localStorage.setItem(SESSION_KEY, JSON.stringify(this._pendingSession));
            this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);
        } catch (e) {
        }
        return this._order;
    }


    setOrderLoadingState(order, state) {
        if (order) {
            this._order = order
            if (state) {
                //noinspection JSUnresolvedVariable
                this._order.loading = state;
            }

            this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);
        }

        return this._order;
    }

    clearPendingSessions() {
        this._pendingSession = undefined;
        try {
            localStorage.removeItem(SESSION_KEY);
        } catch (e) {
        }

    }

    clearLoyalties() {
        try {
            localStorage.removeItem('loyalties');
        } catch (e) {
        }
    }


    getBookings() {
        if (!this.booking) {
            try {
                //todo check if sessionEXPIRED

                this.booking = JSON.parse(localStorage.getItem("CURRENT_BOOKING"));
            }
            catch (e) {
            }
        }
        return this.booking;
    }

    setBooking(booking) {
        if (!booking) return;
        this.booking = booking;
        try {
            localStorage.setItem("CURRENT_BOOKING", JSON.stringify(booking));
        } catch (e) {
        }
    }

    getAllOrders() {
    }

    getOrderAndSeatData(SessionId = this.SessionId, CinemaId = this.CinemaId) {
        return this.getOrder(SessionId).then(order => {
            //console.log("getOrderAndSeatData")
            return this.getSeatGrid(SessionId, CinemaId, order.TicketsForSeating)
        })
        //return Promise.all([this.getOrder(SessionId), this.getSeatGrid(SessionId, CinemaId)])
    }

    // saveOrder(Order = this._order) {
    //
    //     if (!Order) throw new Error('OrderService.saveOrder:: Missing 1st argument - Order can\'t be null');
    //
    //
    //     return this._order_promise = ApiHttp.put('/order', {
    //         Order
    //     }).then((response)=>this._processOrder(response.data), (rejection)=>this._handleRejection(rejection));
    // }

    saveOrderTicketsOnly(Order = this._order) {
        if (!Order) throw new Error('OrderService.saveOrder:: Missing 1st argument - Order can\'t be null');


        return this._order_promise = ApiHttp.put('/order/tickets', {
            Order
        }).then((response) => this._processOrder(response.data), (rejection) => this._handleRejection(rejection));
    }

    saveOrderConcessionsOnly(Order = this._order) {
        if (!Order) throw new Error('OrderService.saveOrderConcessionsOnly:: Missing 1st argument - Order can\'t be null');


        return this._order_promise = ApiHttp.put('/order/concessions', {
            Order
        }).then((response) => this._processOrder(response.data), (rejection) => this._handleRejection(rejection));
    }

    saveTicket(Ticket, SessionId, CinemaId) {
    }

    removeTicket(Ticket, SessionId, CinemaId) {
    }

    refreshSeatGrid() {

    }

    getRefUrl() {
        let refUrl = document.location.hostname;
        let refPort = document.location.port;
        if (refPort > 0) {
            refUrl = document.location.hostname + ":" + document.location.port;
        }
        return refUrl;
    }


    makePayment(EFT = false, orderUser) {
        // console.log(this.getRefUrl());
        return ApiHttp.post('/payment/prepare', {
            ref: this.getRefUrl(), // todo remove sterkinkor.nativedev for testing only
            isEFTPayment: EFT,
            orderUser
        }).then(response => {
            // console.log(response);
            if(response != undefined && response != null) {
                if(response.data != undefined && response.data != null) {
                    if (response.data.url) {
                        this.setGenreCount().then(() => {
                            window.location.href = response.data.url
                        })
                    } else {
                        response.success = false
                        return response
                    }
                }
            }
        }, (error) => {
            error.success = false
            return error
        });
    }

    makePaymentConcessions(orderUser) {
        if (!this._order) throw Error("ORDERSERVICE::MAKECONCESSIONPAYMENT No Order supplied");
        let refUrl = document.location.hostname;
        let refPort = document.location.port;
        if (refPort > 0) {
            refUrl = document.location.hostname + ":" + document.location.port;
        }
        return ApiHttp.post('/payment/prepare', {
            ref: refUrl,
            amount: this._order.totalInCents,
            isDonationOrder:true,
            orderUser
        }).then(response => {
            if (response.data.url) {
                window.location.href = response.data.url
            } else {

            }
        }, (error) => {
            this.seatGrid = undefined;
            return Promise.reject(error)
        });
    }

    getTransactionHistory() {
        return this._history_promise = this._history_promise || ApiHttp.get('/member/transactions').then((response) => new ModelArray(response.data, Transaction), (error) => Promise.reject(error));
    }

    getBooking(BookingNumber, BookingId, CinemaId = null) {
        return ApiHttp.get(`/order/booking/${BookingNumber}/${BookingId}/${CinemaId}`).then((r) => new ModelArray(r.data, Booking));
    }

    getBookingHistory() {
        return ApiHttp.get('/member/bookings').then((response) => {
                let bookings = new ModelArray(response.data, Booking);
                return bookings;
            }
            , (error) => Promise.reject(error)
        );
    }

    cancelOrder(session_id = undefined, cinema_id = undefined) {
        return ApiHttp.post("/order/cancel", {SessionId: session_id, CinemaId: cinema_id}).then(response => {
            localStorage.removeItem("humanzTracking")
            return response
        }, (error) => {
            return Promise.reject(error)
        });
    }

    continueOrder() {
        return ApiHttp.post("/order/continue").then((response) => {
                Object.assign(this._order, response.data);
                this._order.setDates(response.data.ExpiryDate, response.data.LastUpdated);

                this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);
                return response.data
            },
            (error) => {
                Promise.reject(error)
            });
    }

    newConcessionOrder(concession, cinema_id) {
        return ApiHttp.post("/concession/order", {
            concessions: [concession],
            CinemaId: cinema_id
        }).then((response) => {
                return response
            },
            (error) => {
                Promise.reject(error)
            })
    }

    cancelConcessionOrder(cinema_id) {
        if (this._order) {
            return ApiHttp.post("/order/cancel", {CinemaId: cinema_id}).then(response => {
                return response
            }, (error) => {
                return Promise.reject(error)
            });
        }

        return true
    }

    getConcessionOrder() {
        return this._order_promise = ApiHttp.get('/order').then((response) => this._processOrder(response.data), this._handleRejection)
    }

    getPaymentConfig() {
        return ApiHttp.get('/payment/config').then((response) => {
            return response.data
        });
    }

    generateConfirmationPDF(booking_base_id, booking_number, cinema_id) {
        return ApiHttp.defaults.baseLinkURL + `/storage/pdf/${booking_base_id}/${booking_number}/${cinema_id}`;
    }

    removeSession(session_id) {
        return this.cancelOrder(session_id).then((response) => {
            this._order.setDates(response.data.ExpiryDate, response.data.LastUpdated);
            this._order.removeSession(session_id);
            return this._order
        })

    }

    setGenreCount() {
        if(!this._order.Session) return new Promise((resolve)=>resolve());

        return Promise.all([AuthService.user(), this._order.Session.MoviePromise]).then(([user, movie]) => {
            if (user.isGuest()) return;
            try {
                let genres = this._order.Genres;
                let storedGenlocalStorage = localStorage.getItem('genres');
                storedGenlocalStorage = storedGenlocalStorage ? JSON.parse(storedGenlocalStorage) : {};
                for (let i = 0; i < genres.length; i++) {
                    let genre = genres[i];
                    if (!~user.PreferredGenres.indexOf(parseInt(genre.id))) {
                        if (!storedGenlocalStorage.hasOwnProperty(genre.id)) {

                            storedGenlocalStorage[genre.id] = 1;
                        } else {
                            storedGenlocalStorage[genre.id] = parseInt(storedGenlocalStorage[genre.id]) + 1;
                        }
                    } else delete storedGenlocalStorage[genre.id];
                }

                localStorage.setItem("genres", JSON.stringify(storedGenlocalStorage));
            } catch (e) {
            }
            return true;
        })
    }

    commitGenreCount() {
        return AuthService.user().then((user) => {
            if (user.isGuest()) return;
            try {
                let storedGenlocalStorage = localStorage.getItem('genres');
                storedGenlocalStorage = storedGenlocalStorage ? JSON.parse(storedGenlocalStorage) : {};
                for (var i = 0; i < Object.keys(storedGenlocalStorage).length; i++) {
                    var key = Object.keys(storedGenlocalStorage)[i];
                    if (storedGenlocalStorage[key] > 1 && !~user.PreferredGenres.indexOf(parseInt(key))) {
                        user.PreferredGenres.push(parseInt(key));
                        user.save();
                        delete storedGenlocalStorage[key];
                    }

                }
                localStorage.setItem("genres", JSON.stringify(storedGenlocalStorage));
            } catch (e) {
            }
            return true;
        })
    }

    getStandAloneCinemaId(cinema_type) {
        return ApiHttp.get('/order/standalone-cinema-id').then((response) => { return response.data.CinemaId })
    }

    prepareSubs(card, item, user, pin) {
        return ApiHttp.post("/payment/prepare-subs", {'card': card, 'item': item, 'userDetails': user, 'pin': pin}).then(response => {
            return response
        }, (error) => {
            return Promise.reject(error)
        });
    }

    prepareSubsUpdateDetails(card) {
        return ApiHttp.post("/payment/prepare-subs-update-details", {'card': card}).then(response => {
            return response
        }, (error) => {
            return Promise.reject(error)
        });
    }

    updateSubsPaymentDetails(card) {
        return ApiHttp.post("/payment/update-details", {card: card}).then(response => {
            return response
        }, (error) => {
            return Promise.reject(error)
        });
    }

    getApiHttpDefaultBaseLinkUrl() {
        return ApiHttp.defaults.baseLinkURL;
    }

    getSessionAvailableSeatCount(session_id) {
        return ApiHttp.get("/order/get-session-available-seat-count/"+session_id).then(response => {
            //console.log("getSessionAvailableSeatCount",response);
            return response;
        })
    }

    addVistaVoucherTicket(sessionId, Qty, NewTicketTypeCode, OriginalTicketTypeCode, AreaCategoryCode, Barcode) {
        return ApiHttp.put('/order/add-vista-voucher-ticket', {
            qty: Qty,
            newTicketTypeCode: NewTicketTypeCode,
            originalTicketTypeCode: OriginalTicketTypeCode,
            areaCategoryCode: AreaCategoryCode,
            sessionId: sessionId,
            barcode: Barcode
        }).then((response=> {
            //console.log("response OrderService::addVistaVoucherTicket", response.data)
            return this._processOrder(response.data)
        }), (rejection) => this._handleRejection(rejection));
    }

    removeVistaVoucherTicket(sessionId, cinemaId, ticket) {
        return ApiHttp.put('/order/remove-vista-voucher-ticket', {
            sessionId: sessionId,
            cinemaId: cinemaId,
            ticket: ticket
        }).then((response => {
            return this._processOrder(response.data)
        }), (rejection) => this._handleRejection(rejection));
    }

    removeVistaLoyaltyTicket(sessionId, cinemaId, ticket) {
        return ApiHttp.put('/order/remove-vista-loyalty-ticket', {
            sessionId: sessionId,
            cinemaId: cinemaId,
            ticket: ticket
        }).then((response => {
            return this._processOrder(response.data)
        }), (rejection) => this._handleRejection(rejection));
    }

    addVistaSeatsForLoyaltyCard(sessionId, Qty, NewTicketTypeCode, OriginalTicketTypeCode, AreaCategoryCode, MemberCard) {
        return ApiHttp.put('/order/add-vista-seat-for-ticket-type', {
            qty: Qty,
            newTicketTypeCode: NewTicketTypeCode,
            originalTicketTypeCode: OriginalTicketTypeCode,
            areaCategoryCode: AreaCategoryCode,
            sessionId: sessionId,
            memberCard: MemberCard
        }).then((response=> {
            //console.log("response OrderService::addVistaSeatsForLoyaltyCard", response.data)
            //return this._processOrder(response.data)
        }), (rejection) => this._handleRejection(rejection));
    }

    addVistaSeatsForTicket(ticket, sessionId) {
        //console.log("OrderService::addVistaSeatsForTicket")
        return ApiHttp.put('/order/add-vista-ticket', {
            ticket: ticket,
            sessionId: sessionId
        }).then((response=> {
            return this._processOrder(response.data)
        }), (rejection) => this._handleRejection(rejection));
    }

    removeVistaSeatsForTicket(position, status, ticketTypeCode, sessionId) {
        return ApiHttp.put('/order/remove-vista-ticket', {
            position: position,
            status: status,
            ticketTypeCode: ticketTypeCode,
            sessionId: sessionId
        }).then((response=> {
            return this._processOrder(response.data)
        }), (rejection) => this._handleRejection(rejection));
    }

    getDefaultTicketTypeForSession(session_id, cinema_id, areaCategoryCode) {
        return ApiHttp.get(`/order/get-default-ticket-type-for-session/${session_id}/${cinema_id}/${areaCategoryCode}`).then(response => {
            return response;
        })
    }

}


export default new

OrderService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/order-service.js